import React from 'react';
import { Result } from 'antd';

import { Button } from './button';

export interface NotFoundResultProps {
  message?: string | React.ReactElement;
}

export const NotFoundResult: React.FC<NotFoundResultProps> = ({ message }) => {
  return (
    <Result
      status="404"
      title="404"
      subTitle={message || 'Sorry, the page you visited does not exist.'}
      extra={<Button type="primary">Back Home</Button>}
    />
  );
};
